import React from 'react';
import { BankInstrumentId } from '../../types';
import { InstrumentParams } from '../../../../types/common';
import { subSchema } from '../../consts';

interface Props {
  id: BankInstrumentId;
  parameters: InstrumentParams;
}

export const ActualForm: React.FC<Props> = ({ id, parameters }) => {
  const { Content } = subSchema[id];
  return <Content parameters={parameters} />;
};
